import { useState } from 'react';
import { JobBody } from 'services/types';
import { usePostNewJobMutation } from 'services/newApi/jobsApi';
import { useAppSelector } from 'state/store';
import { prtflRefreshOnlyReportSelector } from 'state/store/selectors';
import { showNotification } from 'shared/components/Notification';

type UseReloadFromSFTP = {
  reload: () => Promise<void>;
  isLoading: boolean;
};

export const useReloadFromSFTP = (): UseReloadFromSFTP => {
  const [isLoading, setLoading] = useState(false);
  const [postJob] = usePostNewJobMutation();
  const { selectedContext } = useAppSelector((state) => state.contextsState);
  const { selectedValuationDate } = useAppSelector(
    (state) => state.valuationDatesState
  );
  const report = prtflRefreshOnlyReportSelector(
    useAppSelector((state) => state)
  );

  const reload = async () => {
    setLoading(true);

    // TODO: Hardcoded for test reason, should update
    const body: JobBody = {
      portfolioIds: [],
      reportConfigId: report?.reportConfigurationId ?? '',
      valuationDate: selectedValuationDate,
    };

    await postJob({ body, context: selectedContext })
      .unwrap()
      .then(() => {
        showNotification({
          errorObject: {
            message: 'This may take several minutes',
            code: 'Reloading Portrolios from SFTP',
          },
          type: 'info',
        });
      });

    setLoading(false);
  };

  return { reload, isLoading };
};
